// extracted by mini-css-extract-plugin
export default {"console":"Console_console__5qCIc","input":"Console_input__80F-J","output":"Console_output__uX1Jz"};